<template>
  <v-card>
    <GenericListTableV2
      :parentID="this.parentID"
      :title="`Organisations`"
      :headers="[
        { text: 'ID', value: 'id' },
        { text: 'Organisation Name', value: 'companyname' },
        { text: 'Organisation Description', value: 'description', editable: true},
      ]"
      :url="`/schemas/organisations`"
      :apiResponseField="`organisations`"
      :onClickRoute="`OrganisationSingle`"
      :onClickParams="getOnClickParams"
    >
    </GenericListTableV2>
  </v-card>
</template>

<script>
import GenericListTableV2 from '@/components/Common/GenericListTableV2'
export default {
  name: 'OrganisationListTable',
  components: { GenericListTableV2 },
  props: {
    parentID: {
      type: Number,
      default: null
    }
  },
  methods: {
    getOnClickParams (item) {
      return {
        id: item.id
      }
    }
  }
}
</script>
